import createDOMPurify from 'dompurify';
import { Marked } from 'marked';
import { baseUrl } from 'marked-base-url';

let DOMPurify;
if (import.meta.env.SSR) {
  const { JSDOM } = await import('jsdom');
  const { window } = new JSDOM('');
  DOMPurify = createDOMPurify(window);
} else {
  DOMPurify = createDOMPurify(window);
}

/**
 * Renders Markdown content to sanitized HTML.
 *
 * @param content The Markdown content to render.
 * @returns The rendered HTML content.
 */
export function renderMd(content: string) {
  if (!content) {
    return '';
  }
  let base = inject('url') as string;
  if (!base.endsWith('/')) {
    base += '/';
  }
  const marked = new Marked();
  marked.use(baseUrl(base));
  return DOMPurify.sanitize(marked.parse(content, { gfm: true }) as string);
}
